/**
 * A listakártyákhoz használt thumbnail URL-je az eredeti képből származtatva.
 * Konvenció (backend/src/utils/r2Uploader.js getThumbKey): a kiterjesztés helyett `_thumb.webp`.
 * Relatív (pl. /images/default-provider.jpg) és helyi /uploads URL-eknél nincs thumb,
 * ezeket változatlanul adjuk vissza.
 */
export const getThumbUrl = (url) => {
  if (!url || !/^https?:\/\//i.test(url)) return url;
  return url.replace(/\.[^./]+$/, '') + '_thumb.webp';
};
